/* =================== VOLTAR AO TOPO =================== */
jQuery(document).ready(function ($) {
  function toggleGoTop() {
    var scrollTop = $(window).scrollTop();
    if (scrollTop > 100) {
      $(".gotop").addClass("active");
    } else {
      $(".gotop").removeClass("active");
    }
  }
  toggleGoTop();
  $(window).on(
    "scroll",
    debounce(function () {
      toggleGoTop();
    }, 100)
  );
  $(".gotop").on("click", function () {
    scrollToX("html");
  });

  function campoIns() {
    if ($("#00NHp00000jAm83").val() == "Sim") {
      $("#inscricao").show();
      $("#00NHp00000jAm8I").show();
      $("#00NHp00000jAm8I").val("");
      $("#00NHp00000jAm8I").attr("required", true);
    } else {
      $("#inscricao").hide();
      $("#00NHp00000jAm8I").hide();
      $("#00NHp00000jAm8I").attr("required", false);
    }
  }
  campoIns();
  $("#00NHp00000jAm83").on("change", function () {
    campoIns();
  });
});
